const defaultState = () => ({
    inventoryActivity: {},
});

const mutations = {
    setInventoryActivityState(state, inventoryActivity) {
        state.inventoryActivity = inventoryActivity;
    },
    resetInventoryActivityState(state) {
        state.inventoryActivity = {};
    },
};

const actions = {
    async getInventoryActivity({ commit, dispatch }, workOrderId) {
        try {
            const { data } = await this.$rq.getInventoryActivity(workOrderId);
            commit('setInventoryActivityState', data);
        } catch (err) {
            dispatch('resetWorkOrderInfo');
        }
    },
    resetInventoryActivity({ commit }) {
        commit('resetInventoryActivityState');
    },
};

const getters = {
    inventoryActivity: state => state.inventoryActivity,
    hasInventoryActivity: state => (state.inventoryActivity.items
        ? state.inventoryActivity.items.length > 0
        : false
    ),
};

const state = defaultState();

export default {
    state,
    getters,
    actions,
    mutations,
};
